import type { OperationsApartmentTurnover, OperationsCleaningTask } from '@/shared/api';

export const shortTime = (time: string) => time.slice(0, 5);

const dayMonth = (date: string) => `${date.slice(8, 10)}.${date.slice(5, 7)}.`;

/**
 * Fenster einer Reinigung; liegt ein Ende an einem anderen Tag als dem gezeigten, steht das Datum
 * dabei – sonst läse sich die offene Reinigung vom Vortag wie eine von heute.
 */
export function cleaningWindow(task: OperationsCleaningTask, day: string) {
  const at = (date: string | null | undefined, time: string) =>
    date && date !== day ? `${dayMonth(date)} ${shortTime(time)}` : shortTime(time);
  const from = at(task.scheduledFromLocalDate, task.scheduledFromLocalTime);
  const to = task.scheduledToLocalTime
    ? at(task.scheduledToLocalDate, task.scheduledToLocalTime)
    : 'ohne Frist';
  return `${from} – ${to}`;
}

function movement(apartment: OperationsApartmentTurnover, checkIn: string, checkOut: string) {
  if (apartment.isDeparture && apartment.isArrival)
    return `Abreise ${shortTime(checkOut)} → Anreise ${shortTime(checkIn)}`;
  if (apartment.isDeparture) return `Abreise bis ${shortTime(checkOut)}`;
  if (apartment.isArrival) return `Anreise ab ${shortTime(checkIn)}`;
  return null;
}

/** Eine manuelle Sperre steht immer da, auch neben An- oder Abreise. */
export function detailSummary(
  apartment: OperationsApartmentTurnover,
  checkIn: string,
  checkOut: string,
) {
  const parts = [
    movement(apartment, checkIn, checkOut),
    apartment.isManuallyBlocked ? 'Manuell gesperrt' : null,
  ];
  return parts.filter(Boolean).join(' · ') || 'Tagesdetails';
}
